export const environment = {
  production: false,
  storageKey: 'T_ST_K_C',
  rememberMeKey: 'T_RM_K_C',
  base_url: 'https://staging-api.tusangaire.com/api/v1/ServiceProvider/',
  image_base_url:
    'https://staging-api.tusangaire.com/api/v1/Upload/uploadFiles',
  verificationTimerValue: 'verificationTimerValue',
  FcmStorageKey: 'fcm_token_mugabi_company',
  googleKey: 'AIzaSyCYdkjpCWXF9OyNESaylilyoZbQaOjfElE',
  socket_url: 'https://staging-api.tusangaire.com',
  firebase: {
    apiKey: 'AIzaSyC_0lxGxKmDoe4xiuL8U7_FXT73HQwoIqc',
    authDomain: 'tusangaire.firebaseapp.com',
    projectId: 'tusangaire',
    storageBucket: 'tusangaire.firebasestorage.app',
    messagingSenderId: '978595210364',
    appId: '1:978595210364:web:44e920ff5ee87cd3e355f9',
    measurementId: 'G-9FZ64Z9B2T',
    vapidKey:
      'BNqieUNvRzlwuVYVTejFvAan7ZUzS2lEvFUzSdAWRilgd-BjRMjs7biXxSjxXMWpPSljwwcRwGtCq-rJIYqzBDU',
  },
  //   path: '/firebase-messaging-sw.js',
  // scope: '/'
  path: 'https://dev.appgrowthcompany.com/mugabistaging/admin/browser/firebase-messaging-sw.js',
  scope: 'https://dev.appgrowthcompany.com/mugabistaging/admin/browser/',
};
